module.exports = __webpack_public_path__ + "img/safari_1.f7b19aff.png";